/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type CTALink, CTALinkSchema } from './cta-link'
import {
  type Image,
  ImageSchema,
  type SimpleImage,
  SimpleImageSchema,
} from './image'

/* TypeScript */
export type Article = {
  id: string
  title: string
  translatedCategory: string
  text: string
  image: Image | SimpleImage
  link: ContentLink
  category: string
}

// TODO COM-1345 Remove 'guides', make 'articles' required
export type ArticleCardsListApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
  ctaLink?: Maybe<CTALink>
  layout?: Maybe<'carousel' | 'grid'>
} & ({ guides?: Maybe<Article[]> } | { articles?: Maybe<Article[]> })

/* Schemas */
export const ArticleSchema = z.object({
  id: z.string(),
  title: z.string(),
  translatedCategory: z.string(),
  text: z.string(),
  image: z.union([ImageSchema, SimpleImageSchema]),
  link: ContentLinkSchema,
  category: z.string(),
})

export const ArticleCardsListSchema = z.intersection(
  z.object({
    technicalName: z.nullish(z.string()),
    title: z.nullish(z.string()),
    subtitle: z.nullish(z.string()),
    ctaLink: z.nullish(CTALinkSchema),
    layout: z.nullish(z.enum(['carousel', 'grid'])),
  }),
  z.union([
    z.object({ guides: z.nullish(z.array(ArticleSchema)) }),
    z.object({ articles: z.nullish(z.array(ArticleSchema)) }),
  ]),
)

/* Schemas validation */
type TestArticleCardsList = ExpectTrue<
  Equal<ArticleCardsListApiProps, z.infer<typeof ArticleCardsListSchema>>
>
